module.exports = __webpack_public_path__ + "img/logo.efd201f8.png";